import React from 'react';
import './css/Modal.css';

/**
 * 공통 모달 컴포넌트 - 로그아웃/로그인필요/장바구니추가등 동일한 디자인 적용
 * @param {boolean} isOpen - 모달 표시 여부
 * @param {function} onClose - 오버레이/닫기 클릭 시 호출
 * @param {string} title - 제목 (h2)
 * @param {string} description - 본문 (p)
 * @param {boolean} showCloseButton - 헤더 × 버튼 표시 여부
 * @param {React.ReactNode} footer - 푸터 영역 (버튼 등)
 * @param {string} titleAlign - 제목 행 정렬: 'left' | 'center'
 * @param {string} footerAlign - 푸터 정렬: 'left' | 'center' | 'right'
 */
const Modal = ({ isOpen, onClose, title, description, showCloseButton = false, footer, titleAlign = 'center', footerAlign = 'center' }) => {
  if (!isOpen) return null;

  const titleRowClass = ['logout-modal-title-row', titleAlign === 'left' ? 'title-left' : ''].filter(Boolean).join(' ');
  const footerClass = `logout-modal-footer footer-${footerAlign || 'center'}`;

  return (
    <div className="logout-modal-overlay" onClick={onClose}>
      <div className="logout-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="logout-modal-body">
          {showCloseButton ? (
            <div className={titleRowClass}>
              <h2>{title}</h2>
              <button type="button" className="close-btn" onClick={onClose} aria-label="닫기">
                ×
              </button>
            </div>
          ) : (
            <h2>{title}</h2>
          )}
          <p>{description}</p>
        </div>
        <div className={footerClass}>
          {footer}
        </div>
      </div>
    </div>
  );
};

export default Modal;
